export default __webpack_public_path__ + "static/circle-transport-92000244e00e99d5f24f7ad9bbd99c5f.png";